import { Component, EventEmitter, HostListener, inject, Output, Renderer2 } from '@angular/core';
import packageJson from '../../../../../package.json';
import { RouterModule } from '@angular/router';
import { AuthService } from '@utils/auth.service';
import { StorageService } from '@utils/storage.service';
import { ToastService } from '@utils/toast.service';
import { ShowForPermissionsDirective } from '@directives/show-for-permissions.directive';
import { ShowForRolesDirective } from '@directives/show-for-roles.directive';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'main-menu',
  imports: [RouterModule, ShowForPermissionsDirective, ShowForRolesDirective, TagModule],
  templateUrl: './main-menu.component.html',
  styleUrl: './main-menu.component.scss',
})
export class MainMenuComponent {
  private authService = inject(AuthService);
  private toastService = inject(ToastService);
  private storageService = inject(StorageService);
  private renderer = inject(Renderer2);

  public version: string = packageJson.version;

  public lockscreen = async () => {
    await this.authService.lockscreen();
    this.toastService.success('La pantalla se ha bloqueado.');
  };

  public actionsOnResponsiveMobile = () => {
    if (window.matchMedia('(max-width: 992px)').matches === true) {
      document.body.classList.remove('__sidebar-open');
      this.storageService.setItem('sidebarStatus', 'close');
    }
  };

  public onMouseEnter = () => this.renderer.addClass(document.body, 'menu-hovered');

  public onMouseLeave = () => this.renderer.removeClass(document.body, 'menu-hovered');
}
